import React from "react";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import AddButton from "../../../../../../../ui/AddButton";
import Box from "@material-ui/core/Box";
import RoomDialog from "./RoomDialog";
import ResourceDialog from "./ResourceDialog";
import ListItem from "./ListItem";
import DeleteConfirmationModal from "../../../../../../../ui/DeleteConfirmationModal";

export default function ConditionsPanel({
  lesson,
  allRoomTypesList,
  allModuleRoomList,
  addModuleRoomList,
  updateModuleRoom,
  deleteModuleRoom,
  allResourceTypeList,
  allModuleResourceList,
  addModuleResource,
  updateModuleResource,
  deleteModuleResource,

  initialRoom = {
    lessonId: "",
    main: {
      type: "",
      description: ""
    }
  },
  initialResource = {
    lessonId: "",
    main: {
      type: "",
      description: ""
    }
  }
}) {
  const [room, setRoom] = React.useState(initialRoom);
  const [focusedRoom, setFocusedRoom] = React.useState(null);
  const [showRoomDialog, setShowRoomDialog] = React.useState(false);
  const [showRoomEditDialog, setShowRoomEditDialog] = React.useState(false);
  const [showDeleteRoomDialog, setShowDeleteRoomDialog] = React.useState(false);

  const [resource, setResource] = React.useState(initialResource);
  const [focusedResource, setFocusedResource] = React.useState(null);
  const [showResourceDialog, setShowResourceDialog] = React.useState(false);
  const [showResourceEditDialog, setShowResourceEditDialog] = React.useState(
    false
  );
  const [
    showDeleteResourceDialog,
    setShowDeleteResourceDialog
  ] = React.useState(false);

  React.useEffect(() => {
    if (focusedRoom) {
      const room = {
        lessonId: focusedRoom.lessonId,
        main: {
          type: focusedRoom.typeId,
          description: focusedRoom.description
        }
      };
      setRoom(room);
    }
  }, [focusedRoom]);

  React.useEffect(() => {
    if (focusedResource) {
      const resource = {
        lessonId: focusedResource.lessonId,
        main: {
          type: focusedResource.typeId,
          description: focusedResource.description
        }
      };
      setResource(resource);
    }
  }, [focusedResource]);

  const setStateRoom = id => {
    const value = allModuleRoomList.find(item => item.id === id);
    setFocusedRoom(value);
  };

  const setStateResource = id => {
    const value = allModuleResourceList.find(item => item.id === id);
    setFocusedResource(value);
  };

  const changeRoomType = (event, value) => {
    const newState = {
      ...room,
      main: {
        ...room.main,
        type: value
      }
    };
    setRoom(newState);
  };

  const changeRoomDescription = event => {
    setRoom({
      ...room,
      main: {
        ...room.main,
        [event.target.name]: event.target.value
      }
    });
  };

  const changeResourceType = (event, value) => {
    const newState = {
      ...resource,
      main: {
        ...resource.main,
        type: value
      }
    };
    setResource(newState);
  };

  const changeResourceDescription = event => {
    setResource({
      ...resource,
      main: {
        ...resource.main,
        [event.target.name]: event.target.value
      }
    });
  };

  return (
    <Grid container>
      <RoomDialog
        type="add"
        title={`Добавить помещение к ${lesson.typeName} ${lesson.number}`}
        showRoomDialog={showRoomDialog}
        closeRoomDialog={() => setShowRoomDialog(false)}
        allRoomTypesList={allRoomTypesList}
        addModuleRoomList={addModuleRoomList}
        changeRoomType={changeRoomType}
        changeRoomDescription={changeRoomDescription}
        room={room}
        lessonId={lesson.id}
      />
      <RoomDialog
        title={`Редактировать помещение в ${lesson.typeName} ${lesson.number}`}
        showRoomDialog={showRoomEditDialog}
        closeRoomDialog={() => setShowRoomEditDialog(false)}
        allRoomTypesList={allRoomTypesList}
        updateModuleRoom={updateModuleRoom}
        changeRoomType={changeRoomType}
        changeRoomDescription={changeRoomDescription}
        room={room}
        lessonId={lesson.id}
        roomId={focusedRoom && focusedRoom.id}
      />
      <ResourceDialog
        type="add"
        title={`Добавить оборудование к ${lesson.typeName} ${lesson.number}`}
        showResourceDialog={showResourceDialog}
        closeResourceDialog={() => setShowResourceDialog(false)}
        allResourceTypeList={allResourceTypeList}
        addModuleResource={addModuleResource}
        changeResourceType={changeResourceType}
        changeResourceDescription={changeResourceDescription}
        lessonId={lesson.id}
        resource={resource}
      />
      <ResourceDialog
        title={`Редактировать оборудование в ${lesson.typeName} ${lesson.number}`}
        showResourceDialog={showResourceEditDialog}
        closeResourceDialog={() => setShowResourceEditDialog(false)}
        allResourceTypeList={allResourceTypeList}
        updateModuleResource={updateModuleResource}
        changeResourceType={changeResourceType}
        changeResourceDescription={changeResourceDescription}
        lessonId={lesson.id}
        resource={resource}
        resourceId={focusedResource && focusedResource.id}
      />
      <DeleteConfirmationModal
        open={showDeleteRoomDialog}
        handleClose={() => setShowDeleteRoomDialog(false)}
        modalText="Удалить помещение"
        additionalText={focusedRoom && focusedRoom.typeName}
        onConfirm={() =>
          deleteModuleRoom(focusedRoom.id) || setShowDeleteRoomDialog(false)
        }
      />

      <DeleteConfirmationModal
        open={showDeleteResourceDialog}
        handleClose={() => setShowDeleteResourceDialog(false)}
        modalText="Удалить оборудование/ПО"
        additionalText={focusedResource && focusedResource.typeName}
        onConfirm={() =>
          deleteModuleResource(focusedResource.id) ||
          setShowDeleteResourceDialog(false)
        }
      />

      <Grid container alignItems="center">
        <Typography component="div">
          <Box fontSize={14} mr={1}>
            Рекомендуемые виды помещений
          </Box>
        </Typography>
        <AddButton
          onClick={() => setShowRoomDialog(true) || setRoom(initialRoom)}
        />
      </Grid>
      {allModuleRoomList
        .filter(item => item.lessonId === lesson.id)
        .map(item => (
          <ListItem
            key={item.id}
            title={item.typeName}
            desc={item.description}
            openDeleteDialog={() =>
              setStateRoom(item.id) || setShowDeleteRoomDialog(true)
            }
            openEditDialog={() =>
              setStateRoom(item.id) || setShowRoomEditDialog(true)
            }
          />
        ))}
      <Grid container alignItems="center">
        <Typography component="div">
          <Box fontSize={14} mr={1}>
            Рекомендуемые виды оборудования и ПО
          </Box>
        </Typography>
        <AddButton
          onClick={() =>
            setShowResourceDialog(true) || setResource(initialResource)
          }
        />
      </Grid>
      {allModuleResourceList
        .filter(item => item.lessonId === lesson.id)
        .map(item => (
          <ListItem
            key={item.id}
            title={item.typeName}
            desc={item.description}
            openDeleteDialog={() =>
              setStateResource(item.id) || setShowDeleteResourceDialog(true)
            }
            openEditDialog={() =>
              setStateResource(item.id) || setShowResourceEditDialog(true)
            }
          />
        ))}
    </Grid>
  );
}
